import React from "react";
import './termsconditions.css';

function ETTermsConditionsCard() {
    const openNewTab = (url) => {
        window.open(url, '_blank');
    };

    return (
        <div style={{ marginLeft: 5, marginRight: 5 }}>
            <p style={{ textAlign: 'center', fontSize: 20 }}>
                <strong>Terms and Conditions</strong>
            </p>

             <p><strong>1. License & Use</strong><br />
                The app is licensed for personal, non-commercial use only. You may only use it on a device you own or control.</p>

            <p><strong>2. Data & Privacy</strong><br />
                Your personal details are required for secure access and account identification. Vodafone Fiji handles your data in accordance with its
                <a href="https://www.vodafone.com.fj/personal/products-services/m-paisa/m-paisa-mastercard"> Privacy Policy</a>.</p>

            <p><strong>3. Security Responsibility</strong><br />
                You are responsible for keeping your login credentials secure. Vodafone is not liable for any loss or misuse resulting from shared or compromised login details.</p>

            <p><strong>4. Access Requirements</strong><br />
                The app requires access to the internet via Wi-Fi or mobile data (3G/4G). Vodafone cannot guarantee functionality if your device has no connectivity or data balance.</p>

            <p><strong>5. App Updates</strong><br />
                The app may be updated from time to time. To continue using the app, you must install these updates when released.</p>

            <p><strong>6. Liability Disclaimer</strong><br />
                The app is provided "as is", with no guarantees of being error-free or meeting specific expectations. Vodafone is not responsible for any issues caused by the app’s performance.</p>

            <p><strong>7. Service Changes & Termination</strong><br />
                Vodafone reserves the right to update, suspend, or terminate the app and its services without prior notice, especially in cases of account disconnection or breach of terms.</p>

            <p><strong>8. General Conditions</strong><br />
                These terms may change at any time. Continued use of the app indicates acceptance of the latest version. Vodafone’s standard Postpaid and Prepaid conditions also apply.</p>

        </div>
    );
}

export default ETTermsConditionsCard;